import React ,{Component} from 'react';
import { Navigate  } from 'react-router-dom';
import axios from 'axios';

import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ReactToPrint from 'react-to-print';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
//import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox'; 
import FormControlLabel from '@mui/material/FormControlLabel'; 
import dayjs from 'dayjs';
import { addDays } from "date-fns";
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
let strexpenseLedger=[{title:'',year:0}];
let strSaleLedger=[{title:'',year:0}];
let strcategory=[{title:'',year:0}];
let strvendor=[{title:'',year:0}];

export default class FileUpload extends Component {
	
    constructor(props) {
    super(props);
	
	
 var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
	
 this.state = {
	 pr_date: '',pr_isactive:false,
 pr_date1:'',pr_id:'0',
		 
    addopen: false, erropen:false,errormessage:'',errortype:'error',
date:'',	
    btndisabled: false,submitbtn:'save',
    prevaddfile: '',
	btnstock:'Stock',
	btnnonstock:'Non-Stock',
		btnservice:'Service',
	
		pr_ca_id:'',ledgertags:[],expenseledgertags:[],
		category:'',
		CategoryArray:[],cattags:[],vendortags:[],ca_id:'',
		VendorArray:[],
		ischeckboxdisplay:'',
		groupmasterArray:[],
		isnonstock:false,isstock:true,
		isservice:false,
		producttype:1,
		pr_producttype:'',
	    pr_code:'',
	    pr_description:'',
	    pr_ca_id:'',
	    pr_ledger_id:'',ledger_id:'',
	    pr_tax_id:'',
	    pr_ve_id:0,ve_id:'',
	    pr_expensedescription:'',
	    pr_costprice:'',
	   pr_expledger_id:'',expledger_id:'',
	   pr_reorderlevel:'0.00',
	   pr_reorderquantity:'0.00',
	   pr_quantityinhand:'0.00',
	  pr_vendoritemcode:'',
	   pr_openingcostprice:'0.00',
	   pr_location:'',
	   pr_barcode:'',
	   pr_weight:'0.00',
	   pr_unit:"0",
	   pr_customergroup:'',
	    pr_notes:'',
	   pr_cmp_id:'',
	   userid:'',
	   prid:'',
	   pr_exhistingstockonhand:'',
		
	ledgerArray:[],ExpenseledgerArray:[],
	TaxArray:[],
	
	Productpricingarr:[],
	rowsArrayp:[],
	}
	      
	}
	
	
	
Handleclear=()=>{
		
		
		
 this.setState ({
	    pr_date: '',pr_isactive:false,
        pr_date1:'',pr_id:'0',ledgertags:[],expenseledgertags:[],
 	    btnstock:'Stock', btndisabled: false,submitbtn:'save',
        btnnonstock:'Non-Stock',
		btnservice:'Service',
		categoryarray:[],
		pr_ca_id:'',	  pr_vendoritemcode:'',
		category:'',
		CategoryArray:[],ca_id:'',cattags:[],vendortags:[],
		VendorArray:[],
		ischeckboxdisplay:'',
		groupmasterArray:[],
		isnonstock:false,isstock:true,
		isservice:false,
		producttype:1,
		pr_producttype:'',
	    pr_code:'',
	    pr_description:'',

	    pr_ledger_id:'',ledger_id:'',
	    pr_tax_id:'',
	    pr_ve_id:0,ve_id:'',
	    pr_expensedescription:'',
	    pr_costprice:'',
	   pr_expledger_id:'',expledger_id:'',
	   pr_reorderlevel:'0.00',
	   pr_reorderquantity:'0.00',
	   pr_quantityinhand:'0.00',
	  
	   pr_openingcostprice:'0.00',
	   pr_location:'',
	   pr_barcode:'',
	   pr_weight:'0.00',
	   pr_unit:"0",
	   pr_customergroup:'',
	    pr_notes:'',
	   pr_cmp_id:'',
	   userid:'',
	   prid:'',
	   pr_exhistingstockonhand:'',
	 pvdata:[],
		
	
	},()=>{this.CategoryBind();
	this.OnselectGroupMaster();})
		
	}


  handleProdEvent = (e) => {

	this.setState({ addopen: !this.state.addopen, });
	
  }
	
  handleProdClose = (e) => {
    this.setState({
      addopen: !this.state.addopen, 
    },()=>{this.Handleclear();});
	
	
	
	
		   
  };
	
ProductgetDatabyid()
{
	axios.get(localStorage.getItem("ISIurl")+'ajaxproducts.php?action=getall&pr_id='+this.props.prodid+'&pr_cmp_id='+localStorage.getItem("ISIcmpid"))
     
  .then(resp => {  	
    if(resp.data.length>0){
	let strisstock=false,strisnonstk=false,isservice=false,isactive=false,isstoconhand=false;
	if(resp.data[0].pr_producttype=="1")
	{
		strisstock=true;
	}
	if(resp.data[0].pr_producttype=="2")
	{
		strisnonstk=true;
	}
	if(resp.data[0].pr_producttype=="3")
	{
		isservice=true;
	}
	if(resp.data[0].pr_isactive=="1")
	{
		isactive=true;
	}
	if(resp.data[0].pr_exhistingstockonhand=="1")
	{
		isstoconhand=true;
	}
	const catitem={
		title:resp.data[0].subcategory,
		year:resp.data[0].pr_ca_id
	}
	const ledgeritem={
		title:resp.data[0].le_code+" - "+resp.data[0].le_displayname,
		year:resp.data[0].le_id
	}
	
	const expledgeritem={
		title:resp.data[0].explecode+" - "+resp.data[0].expledger,
		year:resp.data[0].pr_expledger_id
	}
	
	const vendritem={title:resp.data[0].ve_businessname,
		year:resp.data[0].pr_ve_id}
			this.setState({  
			 producttype:resp.data[0].pr_producttype,
			 isnonstock:strisnonstk,isstock:strisstock,isservice:isservice,
			 pr_code:resp.data[0].pr_code,	 pr_ca_id:resp.data[0].pr_ca_id,cattags:catitem,
			 pr_description:resp.data[0].pr_description,pr_isactive:isactive,ledgertags:ledgeritem,
			 pr_id:resp.data[0].pr_id,vendortags:vendritem,
			 pr_ledger_id:resp.data[0].pr_ledger_id,pr_tax_id:resp.data[0].pr_tax_id,pr_ve_id:resp.data[0].pr_ve_id,pr_vendoritemcode:resp.data[0].pr_vendoritemcode,pr_expensedescription:resp.data[0].pr_expensedescription,pr_costprice:resp.data[0].pr_costprice,pr_expledger_id:resp.data[0].pr_expledger_id,expenseledgertags:expledgeritem, pr_reorderlevel:resp.data[0].pr_reorderlevel,pr_reorderquantity:resp.data[0].pr_reorderquantity,checkboxvalue:isstoconhand,pr_quantityinhand:resp.data[0].pr_quantityinhand,pr_date:resp.data[0].pr_date,pr_openingcostprice:resp.data[0].pr_openingcostprice,pr_location:resp.data[0].pr_location,pr_barcode:resp.data[0].pr_barcode,pr_weight:resp.data[0].pr_weight,pr_unit:resp.data[0].pr_unit,pr_customergroup:resp.data[0].pr_customergroup,pr_notes:resp.data[0].pr_notes
			});

     }
	 
	  else{
		
	 }
	 
  
    });
}
oncategoryChange = (event, newTextValue) => {

if(newTextValue!==" "){

  this.setState({ca_id:newTextValue})
}
  
 }
 onTagscategoryChange = (event, values) => {
	  
	   if(values!==" " && values!==null){
		  this.setState({  pr_ca_id:values["year"],cattags:values});
	   }
	  
  }
   CategoryBind() {
    axios.get(localStorage.getItem("ISIurl")+"ajaxcategory.php?action=getall&ca_cmp_id="+localStorage.getItem("ISIcmpid"))
            .then((resp) => {
               
				
				 resp.data.map((row, index) => {
                   
					
					 const items = {
        title:row.category_hierarchy,
          year:row.ca_id,
					 }
					 const catfound = strcategory.some(el => el.year === row.year);					 
					 if (!catfound) 
					 strcategory.push(items)
                });
				
				
              this.VendorBind();
                this.setState({CategoryArray: strcategory});
            });
    }


onvendorChange = (event, newTextValue) => {

if(newTextValue!==" "){

  this.setState({ve_id:newTextValue})
}
  
 }
 onTagsvendorChange = (event, values) => {
	  
	   if(values!==" " && values!==null){
		  this.setState({  pr_ve_id:values["year"],vendortags:values});
	   }
	  
  }
  
   VendorBind() {
    axios.get(localStorage.getItem("ISIurl")+"ajaxvendors.php?action=getall&ve_cmp_id="+localStorage.getItem("ISIcmpid"))
            .then((resp) => {
               resp.data.map((row, index) => {
                   // return { value: row.ve_id, display: row.ve_businessname };
					 const items = {
        title:row.ve_businessname,
          year:row.ve_id,
					 }	
 const venfound = strvendor.some(el => el.year === row.year);					 
					 if (!venfound) strvendor.push(items)
                });				
				
              this.GrounpmasterBind();
                this.setState({
                    VendorArray:strvendor
                });
            });
    }




   GrounpmasterBind() {
    axios.get(localStorage.getItem("ISIurl")+"ajaxgroupmaster.php?action=getall&gm_type=3&gm_cmp_id="+localStorage.getItem("ISIcmpid"))
            .then((resp) => {
                let AdminApi = resp.data.map((row, index) => {
                    return { value: row.gm_id, display: row.gm_name };
                });
              this.LedgerBind();
                this.setState({
                    groupmasterArray: [{ value: '0', display: 'Select' }].concat(AdminApi)
                });
            });
    }



   LedgerBind() {
    axios.get(localStorage.getItem("ISIurl")+"ajaxledger.php?action=getall&le_cmp_id="+localStorage.getItem("ISIcmpid")+'&le_issales=1')
            .then((resp) => {
                 resp.data.map((row, index) => {
                    //return { value: row.le_id, display:row.le_code+" - "+ row.le_ledgername };
					
					 const items = {
        title:row.le_code+" - "+ row.le_displayname,
          year:row.le_id,
					 }
					 const ledfound = strSaleLedger.some(el => el.year === row.year);					 
					 if (!ledfound) 
					 strSaleLedger.push( items)
                });
				 this.setState({
                    ledgerArray: strSaleLedger
                });
				
              this.TaxBind();
               
            });
    }
onsalesledgerChange = (event, newTextValue) => {

if(newTextValue!==" "){

  this.setState({ledger_id:newTextValue})
}
  
 }
  onTagssalesledgerChange = (event, values) => {
	  
	   if(values!==" " && values!==null){
		  this.setState({  pr_ledger_id:values["year"],ledgertags:values});
	   }
	  
  }
   ExpenseLedgerBind() {
    axios.get(localStorage.getItem("ISIurl")+"ajaxledger.php?action=getall&le_cmp_id="+localStorage.getItem("ISIcmpid")+'&le_isexpenses=1')
            .then((resp) => {
                let AdminApi = resp.data.map((row, index) => {
                   // return { value: row.le_id, display:row.le_code+" - "+ row.le_ledgername };
                const items = {
        title:row.le_code+" - "+ row.le_displayname,
          year:row.le_id,
					 }
					 const ledfound = strexpenseLedger.some(el => el.year === row.year);					 
					 if (!ledfound) strexpenseLedger.push( items)
                });
				 this.setState({
                    ExpenseledgerArray: strexpenseLedger
                });
           
               if(this.props.prodid!=0)
	{
		 
		this.ProductgetDatabyid();
	} 
            });
    }

onexpenseledgerChange = (event, newTextValue) => {

if(newTextValue!==" "){

  this.setState({expledger_id:newTextValue})
}
  
 }
  onTagsexpenseledgerChange = (event, values) => {
	  
	   if(values!==" " && values!==null){
		  this.setState({  pr_expledger_id:values["year"],expenseledgertags:values});
	   }
	  
  }

   TaxBind() {
	   
	    axios.get(localStorage.getItem("ISIurl")+'ajaxtax.php?action=getall&tx_cmp_id='+localStorage.getItem("ISIcmpid")+'&tx_mainid=0')
    
      .then((resp) => {   
	  
	  let TaxApi = resp.data.map(row => {
                      
          return {value: row.tx_id, display:row.taxs}
        });
		 this.ExpenseLedgerBind();
		 this.setState({
          TaxArray: [{ value: '0', display: 'Select' }].concat(TaxApi)
        },()=>{});
      }).then(data => {       
      })
    
    }

handleCheckboxChange = (event) => {
     this.setState({ischeckboxdisplay:!this.state.ischeckboxdisplay,checkboxvalue:!this.state.checkboxvalue});
}

  handleProdactive = (event) => {
	 this.setState({pr_isactive:!this.state.pr_isactive}); 
  }

fromdatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);

       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }

    
    this.setState({
        pr_date: dayjs(dateObj),
        pr_date1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    });
}


handlenonstock=()=>{
	this.setState({isnonstock:true,producttype:2,isstock:false,isservice:false,});
	
	
}
handlestock=()=>{
	this.setState({producttype:1,isnonstock:false,isstock:true,
		isservice:false,});
	
	
}


handlenService=()=>{
	this.setState({isservice:true,producttype:3,isstock:false,isnonstock:false,});
	
	
}
 myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  
  
   const regex = /^[0-9\b]+$/;
    const regex1 = /^[0-9.\b]+$/;
    if( nam==="pr_quantityinhand" )
  {
	  if (event.target.value === '' || regex.test(event.target.value)) {
	  this.setState({[nam]: val}); 
  }
  }
   if(nam==="pr_costprice" ||  nam==="pr_openingcostprice" || nam==="pr_weight" || nam==="pr_reorderlevel" || nam==="pr_reorderquantity" )
  {
	  if (event.target.value === '' || regex1.test(event.target.value)) {
	  this.setState({[nam]: val}); 
  }
  }
  else{
  this.setState({[nam]: val});
  }

 } 


/*insert */



  handleSubmit =(e) => {
  e.preventDefault();
   let optionsVal = this.state.Productpricingarr;
     let sep1 = "",strvalidate="0";;
     let optionValues = "";
  if(this.state.pr_code==="")
{
	
	this.setState({errormessage:"Please Enter Item Code   ",erropen:true});
		 window.scrollTo({top: 0})
		 return false;
}
  if(this.state.pr_description==="")
{
	
	this.setState({errormessage:"Please Enter Item Description ",erropen:true});
		 window.scrollTo({top: 0})
		 return false;
}
if(this.state.pr_ca_id==="")
{
	
	this.setState({errormessage:"Please Enter Category ",erropen:true});
		 window.scrollTo({top: 0})
		 return false;
}

  

    optionsVal.forEach((eachval) => {
    
		  if( eachval.price!="0")
		  {
		  
        optionValues += sep1 + eachval.gmid + "~" + eachval.price + "~" + eachval.includetax+"~"+localStorage.getItem("ISIuserid")+"~"+eachval.pp_id;
        sep1 = ";";
		  }
		  else{
			strvalidate="1";  
		  }
      
    });
	
	if(strvalidate==="1")
{
	
	this.setState({errormessage:"Please Enter Sales Price ",erropen:true});
		 window.scrollTo({top: 0})
		 return false;
}
	if(this.state.pr_ledger_id==="0" || this.state.pr_ledger_id==="")
{
	
	this.setState({errormessage:"Please Enter Sales Account",erropen:true});
		 window.scrollTo({top: 0})
		 return false;
}
	if(this.state.pr_tax_id==="0" || this.state.pr_tax_id==="")
{
	
	this.setState({errormessage:"Please Select Tax",erropen:true});
		 window.scrollTo({top: 0})
		 return false;
}
if(this.state.pr_costprice==="")
{
	
	this.setState({errormessage:"Please Enter Cost Price",erropen:true});
		 window.scrollTo({top: 0})
		 return false;
}
if(this.state.pr_expledger_id==="" || this.state.pr_expledger_id==="0")
{
	
	this.setState({errormessage:"Please Enter Expense Account",erropen:true});
		 window.scrollTo({top: 0})
		 return false;
}
 if(this.state.ischeckboxdisplay===true){
if(this.state.pr_quantityinhand==="" || this.state.pr_quantityinhand==="0.00")
{
	
	this.setState({errormessage:"Please Enter Quantity on Hand",erropen:true});
		 window.scrollTo({top: 0})
		 return false;
}
if(this.state.pr_openingcostprice==="" || this.state.pr_openingcostprice==="0.00")
{
	
	this.setState({errormessage:"Please Enter Opening Cost Price",erropen:true});
		 window.scrollTo({top: 0})
		 return false;
}

if(this.state.pr_date1==="" )
{
	
	this.setState({errormessage:"Please Enter As of Date",erropen:true});
		 window.scrollTo({top: 0})
		 return false;
}

 }
	
  this.setState({btndisabled:true,submitbtn:"Processing...",errormessage:"",erropen:false})
  var formData = new FormData();
         formData.append('action','insertorupdate')
      if(this.state.pr_id === "0" || this.state.pr_id === null)
	  {
		   formData.append('pr_id',0)
	  }
	  else
	  {
		  formData.append('pr_id',this.state.pr_id)
	  }
      
	   formData.append('pr_producttype',this.state.producttype)
	   formData.append('pr_code',this.state.pr_code)
	   formData.append('pr_description',this.state.pr_description)
	   formData.append('pr_ca_id',this.state.pr_ca_id)
	   formData.append('pr_ledger_id',this.state.pr_ledger_id)
	   formData.append('pr_tax_id',this.state.pr_tax_id)
	   formData.append('pr_ve_id',this.state.pr_ve_id)
	   formData.append('pr_expensedescription',this.state.pr_expensedescription)
	   formData.append('pr_costprice',this.state.pr_costprice)
	   formData.append('pr_expledger_id',this.state.pr_expledger_id)
	   
	   formData.append('pr_location',this.state.pr_location)
	   formData.append('pr_barcode',this.state.pr_barcode)
	   formData.append('pr_weight',this.state.pr_weight)
	   formData.append('pr_unit',this.state.pr_unit)
	     formData.append('pr_vendoritemcode',this.state.pr_vendoritemcode)
	   
	   if(this.state.pr_customergroup==="" || this.state.pr_customergroup===null){
	   formData.append('pr_customergroup',0)
	   }
	   else{
		    formData.append('pr_customergroup',this.state.pr_customergroup)
		   
	   }
	   formData.append('pr_notes',this.state.pr_notes)
	   formData.append('pr_cmp_id',localStorage.getItem("ISIcmpid"))
	   formData.append('userid',localStorage.getItem("ISIuserid"))

	   if(this.state.pr_isactive===true){
		   formData.append('pr_isactive',1) 
	   }else{
		  formData.append('pr_isactive',0)  
	   }
	   if(this.state.ischeckboxdisplay===true){
	    formData.append('pr_exhistingstockonhand',1)
	    formData.append('pr_quantityinhand',this.state.pr_quantityinhand)
		formData.append('pr_openingcostprice',this.state.pr_openingcostprice)
		formData.append('pr_date',this.state.pr_date1)
	   }
	   else{
		   formData.append('pr_openingcostprice',0)
		   formData.append('pr_quantityinhand',0)
		   formData.append('pr_exhistingstockonhand',0)
		   formData.append('pr_date',"")
	   }
	   
	   if(this.state.producttype===3 || this.state.producttype===2 ){
	   formData.append('pr_reorderlevel',0)
	   formData.append('pr_reorderquantity',0)
		   
	   }else{
		   
	 formData.append('pr_reorderlevel',this.state.pr_reorderlevel)
	   formData.append('pr_reorderquantity',this.state.pr_reorderquantity)
		  
	   }
	   
   
    
 formData.append('productprice',optionValues)
	 
	 
	
	   axios.post(localStorage.getItem("ISIurl")+"ajaxproducts.php", formData, {
        }).then(res => {
	let strreturn=res.data;
	if(strreturn!==0)
	{
	   this.props.updateprodnew(strreturn);
	   this.setState({btndisabled:false,submitbtn:"Save",addopen:false,errormessage:"",erropen:false});
		this.Handleclear();
	}
	else{
		
	
	this.setState({errormessage:"Item code already exist",erropen:true,btndisabled:false,submitbtn:"Save",});
		 window.scrollTo({top: 0})
		 return false;

	}
		})
	
	
  }











OnchangeDrpVendor = (event) => {

 const selectedValue = event.target.value;

    this.setState({
        pr_ve_id: selectedValue
    });
};
  
  
  OnchangeDrpGroupMaster = (event) => {

 const selectedValue = event.target.value;

    this.setState({
        pr_customergroup: selectedValue
    });
};


OnchangeDrpTax = (event) => {

 const selectedValue = event.target.value;

    this.setState({
        pr_tax_id: selectedValue
    });
};
  
  
  
  
  /*productprice*/
  
  
  OnselectGroupMaster(){
	
		 axios.get(localStorage.getItem("ISIurl")+'ajaxgroupmaster.php?action=MasterbyProductid&gm_type=1&gm_cmp_id='+localStorage.getItem("ISIcmpid")+'&productid='+this.props.prodid)
  .then(resp => {  
    let strarraytax=[];
	
   if(resp.data.length>0){
	var rowsArrayp = resp.data;


	this.setState({ Productpricingarr:rowsArrayp})


	   
   }
   
   
  });

} 
myChangeHandlerPV = (index, gmid) => (event) => {
  const { name, value, checked } = event.target;
  let updatedArray = [...this.state.Productpricingarr];

 
  if (name === "price") {
    updatedArray[index].price = value; 
  } else if (name === "includetax") {
    updatedArray[index].includetax = checked ? 1 : 0;  
  }

  
  this.setState({ Productpricingarr: updatedArray }, () => {
    console.log('Updated array:', this.state.Productpricingarr);  

 
  });
};


handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 


  
	render() {
		
		
		
    return (
  <React.Fragment>
  <div className="productbox">
         <Dialog
            open={this.state.addopen}  
            onClose={this.handleProdEvent}
            maxWidth="md"
            fullWidth={true}
         >
            <DialogTitle id="form-dialog-title" className="dialoghead">
           <h3>Create an Item</h3>
           <p className="headsubline"> Create any items that your business buys or sells.</p>
             <div className="Dialogueclose">
      
         <span className="closepricon"  onClick={this.handleProdEvent} >  <CloseIcon /></span>
       
    </div>	
            </DialogTitle>
            <DialogContent>
    
     
            
			<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>

  <div className="iteminformation">
  <h4>Item Information</h4>
 <div className="tables-container">
  
  <Table className="stockbox" style={{ borderSpacing: '0px 20px', width: '100%' }}>
 
    <tbody>
      <tr>
        <td className="table-cell">Select Type  <span className="validation">*</span></td>
        <td className="table-cell">
          <Button
            variant="contained"
            className={this.state.isstock ? 'prodstickbuttontabselect' : "prodstickbuttontab"}
            onClick={this.handlestock}
          >
            {this.state.btnstock}
          </Button>&nbsp;&nbsp;&nbsp;

          <Button
            variant="contained"
        className={this.state.isnonstock ? 'prodstickbuttontabselect' : "prodstickbuttontab"}
            onClick={this.handlenonstock}
          >
            {this.state.btnnonstock}
          </Button>&nbsp;&nbsp;&nbsp;

          <Button
            variant="contained"
        className={this.state.isservice ? 'prodstickbuttontabselect' : "prodstickbuttontab"}
            onClick={this.handlenService}
          >
            {this.state.btnservice}
          </Button>
        </td>
      </tr>
      <tr>
        <td className="table-cell">Item Code <span className="validation">*</span></td>
        <td className="table-cell">
          <TextField
            name="pr_code"
            onChange={this.myChangeHandler}
            fullWidth
			
            className="textbox"
            value={this.state.pr_code}
            ref={this.usernameInput}
            inputProps={{ tabIndex: '1', maxLength: 150 }}
            className="txtbox"
            InputLabelProps={{ shrink: true }}
			placeholder="e.g. Short name or code " 
          />
        </td>
      </tr>
      <tr>
        <td className="table-cell">Item Description <span className="validation">*</span></td>
        <td className="table-cell">
          <TextField
            name="pr_description"
            onChange={this.myChangeHandler}
            fullWidth
            multiline   inputProps={{ tabIndex: '2', }}
            value={this.state.pr_description}
            rows={2}
            ref={this.usernameInput}
            className="txtbox"
            InputLabelProps={{ shrink: true }}
          />
        </td>
      </tr>
      <tr>
        <td className="table-cell" valign="top">Category <span className="validation">*</span></td>
        <td className="table-cell">
         <p>
		   <Autocomplete
      id="custautoextender" 
	  className="txtbox"   inputProps={{ tabIndex: "3" }}
	   inputValue={this.state.ca_id} onInputChange={this.oncategoryChange}
	  onChange={this.onTagscategoryChange}  value={this.state.cattags} 
     options={this.state.CategoryArray}
      renderInput={(params) => (
        <TextField {...params}   variant="outlined" inputProps={{
            ...params.inputProps,
            tabIndex: 3 // <-- set your tab index here
          }}/>
      )}
      getOptionLabel={(option) => option.title || ""} />
		  
		  
		  </p>
		  <p><FormControlLabel
        control={
        <Checkbox
		
            name="pr_isactive"
            checked={this.state.pr_isactive } 
            onChange={this.handleProdactive}
            color="primary"
        />
       }
       label='Active'
     /> 
	 </p>
        </td>
      </tr>
	  
	  
    </tbody>
  </Table>

  <hr />
 <h4>I Sell This Item</h4>
  <Table className="stockbox" style={{ borderSpacing: '0px 20px', width: '100%' }}>
   
    <tbody>
	
	<tr>
  <td valign="top" className="table-cell">Sales Price  <span className="validation">*</span></td>
  <td className="table-cell">
    <Table className="groupbox" cellspacing="1" cellpadding="1" >
      <thead>
        <tr>
          <th >Price Name</th>
          <th >Price</th>
          <th >Includes Tax</th>
        </tr>
      </thead>
  <tbody>
  {this.state.Productpricingarr.length > 0 &&
    this.state.Productpricingarr.map((rows, i) => {
		let strval=parseInt( 4)
      return (
        <tr key={rows.gmid}>  
          <td style={{ border: "1px solid black" }}>{rows.gmname}</td>
          <td style={{ border: "1px solid black" }}>
            <TextField
              name="price"
              onChange={this.myChangeHandlerPV(i, rows.gmid)} 
              fullWidth
              value={rows.price}  
              ref={this.usernameInput}
              inputProps={{ tabIndex: strval, maxLength: 150 }}
              className="txtbox"
              InputLabelProps={{ shrink: true }}
            />
          </td>
          <td style={{ border: "1px solid black" }}>
            <Checkbox
              name="includetax" 
              onChange={this.myChangeHandlerPV(i, rows.gmid)} 
              checked={rows.includetax === 1}  
            />
          </td>
        </tr>
      );
    })}
</tbody>

    </Table>
  </td>
</tr>

	
	
     <tr>
	 <td className="table-cell">Sales Account <span className="validation">*</span></td>
        <td className="table-cell">
        
		  
		  <Autocomplete
      id="custautoextender" 
	  className="txtbox" inputProps={{ tabIndex: '4', }}
	  value={this.state.ledgertags}
		  inputValue={this.state.ledger_id}
		    onInputChange={this.onsalesledgerChange}
	  onChange={this.onTagssalesledgerChange}  
     options={this.state.ledgerArray}
      renderInput={(params) => (
        <TextField {...params}   variant="outlined" inputProps={{
            ...params.inputProps,
            tabIndex: 5 // <-- set your tab index here
          }}/>
      )}
      getOptionLabel={(option) => option.title || ""} />
        </td>
	 
	 
	 
	 </tr>
	  <tr>
	 <td className="table-cell">Tax Rate</td>
        <td className="table-cell">
          <Select
            native
            fullWidth
            variant="outlined"
            margin="normal"
            value={this.state.pr_tax_id}
            onChange={this.OnchangeDrpTax}
            inputProps={{ tabIndex: "5" }}
            className="txtbox"
            id="pr_tax_id"
            name="pr_tax_id"
          >
            {this.state.TaxArray.map((br) => (
              <option key={br.value} value={br.value}>
                {br.display}
              </option>
            ))}
          </Select>
        </td>
	 
	 
	 
	 </tr>
	 
	 
    </tbody>
  </Table>

  <hr />

  <Table className="stockbox" style={{ borderSpacing: '0px 20px', width: '100%' }}>
    <h4>I Buy This Item</h4>
    <tbody>
      <tr>
        <td className="table-cell">Usual Vendor</td>
        <td className="table-cell">
        
		  
		    <Autocomplete
      id="custautoextender" 
	  className="txtbox"
	value={this.state.vendortags}
		  inputValue={this.state.ve_id}
		    onInputChange={this.onvendorChange}
	  onChange={this.onTagsvendorChange}  
     options={this.state.VendorArray}
      renderInput={(params) => ( <TextField {...params}   variant="outlined" inputProps={{
            ...params.inputProps,
            tabIndex: 6 // <-- set your tab index here
          }}/>)}
      getOptionLabel={(option) => option.title || ""} />
        </td>
      </tr>
	    {this.state.isnonstock===false && this.state.isservice===false &&(
	  <tr>
	  <td className="table-cell">Vendor Item Code</td>
        <td className="table-cell">
         <TextField
            name="pr_vendoritemcode"
            onChange={this.myChangeHandler}
            fullWidth
            className="textbox"
            value={this.state.pr_vendoritemcode}
            ref={this.usernameInput}
            inputProps={{ tabIndex: '7', maxLength: 150 }}
            className="txtbox"
            InputLabelProps={{ shrink: true }}
          />
        </td>
	  
		</tr>)}
	  
	  <tr>
	   <td className="table-cell">Expense Description</td>
        <td className="table-cell">
          <TextField
            name="pr_expensedescription"
            onChange={this.myChangeHandler}
            fullWidth inputProps={{ tabIndex: '8', }}
            multiline
            value={this.state.pr_expensedescription}
            rows={2}
            ref={this.usernameInput}
            className="txtbox"
            InputLabelProps={{ shrink: true }}
          />
        </td>
	  </tr>
	  
	  
	  
	  
	   <tr>
	   <td className="table-cell">Cost Price <span className="validation">*</span></td>
        <td className="table-cell">
         <TextField
            name="pr_costprice"
            onChange={this.myChangeHandler}
            fullWidth
            className="textbox"
            value={this.state.pr_costprice}
            ref={this.usernameInput}
            inputProps={{ tabIndex: '9', maxLength: 150 }}
            className="txtbox"
            InputLabelProps={{ shrink: true }}
          />
        </td>
	  </tr>
	  
	  
	  
	  
	   <tr>
	   <td className="table-cell">Expense Account <span className="validation">*</span></td>
      
        <td className="table-cell">
          
		   <Autocomplete
      id="custautoextender" 
	  className="txtbox"
	  value={this.state.expenseledgertags}
		  inputValue={this.state.expledger_id}
		    onInputChange={this.onexpenseledgerChange}
	  onChange={this.onTagsexpenseledgerChange}  
     options={this.state.ExpenseledgerArray}
      renderInput={(params) => (
        <TextField {...params}   variant="outlined" inputProps={{
            ...params.inputProps,
            tabIndex:10 // <-- set your tab index here
          }}/>
      )}
      getOptionLabel={(option) => option.title || ""} />
        </td>
	  </tr>
	  
	  {this.state.isnonstock===false && this.state.isservice===false &&(
	  <React.Fragment>
	   <tr>
	   <td className="table-cell">Reorder Level</td>
        <td className="table-cell">
         <TextField
            name="pr_reorderlevel"
            onChange={this.myChangeHandler}
            fullWidth
            className="textbox"
            value={this.state.pr_reorderlevel}
            ref={this.usernameInput}
            inputProps={{ tabIndex: '11', maxLength: 150 }}
            className="txtbox"
            InputLabelProps={{ shrink: true }}
          />
        </td>
	  </tr>
	  
	  
	   <tr>
	   <td className="table-cell">Reorder Quantity</td>
        <td className="table-cell">
         <TextField
            name="pr_reorderquantity"
            onChange={this.myChangeHandler}
            fullWidth
            className="textbox"
            value={this.state.pr_reorderquantity}
            ref={this.usernameInput}
            inputProps={{ tabIndex: '12', maxLength: 150 }}
            className="txtbox"
            InputLabelProps={{ shrink: true }}
          />
        </td>
	  </tr>
	  </React.Fragment>)}
	  
    </tbody>
  </Table>
  
  
 
   {this.state.isnonstock===false  && this.state.isservice===false &&(
   <React.Fragment>   <hr/> <h4>Opening Balance</h4>
    <Table className="stockbox" style={{ borderSpacing: '0px 20px', width: '100%' }}>
 
	
	<p><FormControlLabel
        control={
        <Checkbox
		
            name="checkboxvalue" inputProps={{ tabIndex: '13', }}
            checked={this.state.checkboxvalue } 
            onChange={this.handleCheckboxChange}
            color="primary"
        />
       }
       label='I have existing stock on hand'
     /> 
	 </p>
	
    <tbody>
	{this.state.ischeckboxdisplay === true  &&(
      <React.Fragment> <tr>
	 <td className="table-cell">Quantity on Hand <span className="validation">*</span></td>
        <td className="table-cell">
         <TextField
            name="pr_quantityinhand"
            onChange={this.myChangeHandler}
            fullWidth
            className="textbox"
            value={this.state.pr_quantityinhand}
            ref={this.usernameInput}
            inputProps={{ tabIndex: '14', maxLength: 150 }}
            className="txtbox"
            InputLabelProps={{ shrink: true }}
          />
        </td>
	
      </tr>
	  
	  
	  <tr>
	   <td className="table-cell">As of Date <span className="validation">*</span></td>
        <td className="table-cell">
	    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
      <DatePicker
     value= {dayjs(this.state.pr_date) }
      className="txtbox" inputProps={{ tabIndex: '15', }}
     onChange={this.fromdatehandler} format="MM/DD/YYYY"
       />  </DemoContainer>
     </LocalizationProvider>
		</td>
		</tr>
	  
	  <tr>
	  
	  <td className="table-cell">Cost Price <span className="validation">*</span></td>
        <td className="table-cell">
          <TextField
            name="pr_openingcostprice"
            onChange={this.myChangeHandler}
            fullWidth
            className="textbox"
            value={this.state.pr_openingcostprice}
            ref={this.usernameInput}
            inputProps={{ tabIndex: '16', maxLength: 150 }}
            className="txtbox"
            InputLabelProps={{ shrink: true }}
          />
        </td>
	  
	</tr>  </React.Fragment>)}
    </tbody>
   </Table> </React.Fragment>)}
  
  
  
  <hr/>
     <h4>Additional Information</h4>
  <Table className="stockbox" style={{ borderSpacing: '0px 20px', width: '100%' }}>
 
    <tbody>
	{this.state.isnonstock===false && this.state.isservice===false &&(
	
	<React.Fragment>
	   <tr>
	  <td className="table-cell">Location</td>
        <td className="table-cell">
          <TextField
            name="pr_location"
            onChange={this.myChangeHandler}
            fullWidth
            className="textbox"
            value={this.state.pr_location}
            ref={this.usernameInput}
            inputProps={{ tabIndex: '17', maxLength: 150 }}
            className="txtbox"
            InputLabelProps={{ shrink: true }}
          />
        </td>
	  
	</tr> 
	
	
	  <tr>
	  
	  <td className="table-cell">Barcode</td>
        <td className="table-cell">
          <TextField
            name="pr_barcode"
            onChange={this.myChangeHandler}
            fullWidth
            className="textbox"
            value={this.state.pr_barcode}
            ref={this.usernameInput}
            inputProps={{ tabIndex: '18', maxLength: 50 }}
            className="txtbox"
            InputLabelProps={{ shrink: true }}
          />
        </td>
	  
	  </tr> 
	  
	  
	   <tr>
	  
	  <td className="table-cell">Weight</td>
        <td className="table-cell">
          <TextField
            name="pr_weight"
            onChange={this.myChangeHandler}
            fullWidth
            className="textbox"
            value={this.state.pr_weight}
            ref={this.usernameInput}
            inputProps={{ tabIndex: '19', maxLength: 150 }}
            className="txtbox"
            InputLabelProps={{ shrink: true }}
          />
        </td>
	  
	  </tr> 
	  <tr><td className="table-cell">Unit</td>
	  <td className="table-cell">  <Select
         native
		 variant="outlined" className="txtbox"
          margin="normal"
          onChange={this.myChangeHandler}
          id="pr_unit"
		   value={this.state.pr_unit}
		  name="pr_unit"
		inputProps={{tabIndex: "20"}}
        >
	    <option value={0}>Select Unit</option>
	    <option value={1}>Ounce(oz)</option>
	    <option value={2}>Pound(lb)</option>	
	     <option value={3}>on(t)</option>	
        </Select></td>
	  </tr>
	  
	  
	  
	  <tr>
	  
	  
	  <td className="table-cell">Customer Group</td>
        <td className="table-cell">
		
		 <Select
            native
            fullWidth
            variant="outlined"
            margin="normal"
            value={this.state.pr_customergroup}
            onChange={this.OnchangeDrpGroupMaster}
            inputProps={{ tabIndex: "21" }}
            className="txtbox"
            id="pr_customergroup"
            name="pr_customergroup"
          >
            {this.state.groupmasterArray.map((br) => (
              <option key={br.value} value={br.value}>
                {br.display}
              </option>
            ))}
          </Select>
		
		</td>
	  
	  </tr>
	 </React.Fragment> )}
	  <tr>
	
	   <td className="table-cell">Notes</td>
        <td className="table-cell">
          <TextField
            name="pr_notes"
            onChange={this.myChangeHandler}
            fullWidth
            multiline inputProps={{ tabIndex: '22', }}
            value={this.state.pr_notes}
            rows={4}
            ref={this.usernameInput}
            className="txtbox" 
           
          />
        </td>
	  
	  </tr>
	  
    </tbody>
  </Table>
  
  
  
  
</div>
</div>
	
			
			
			
			
			
   
            <div className="actionbtns">
              <div className="cancelbtn">
                <Button
                  variant="contained"
                  className="frmthirdbtn"
                  onClick={this.handleProdEvent} 
                >
                  Close
                </Button>
              </div>
              <div className="savebtn">
			  {this.state.errormessage!=="" && (
			  
			  <span className="validation">There are some error</span>
			  )}
			  
                <Button
                  variant="contained" disabled={this.state.btndisabled}
                  className="frmSecondarybtn"
                  onClick={this.handleSubmit}
                >
				{this.state.submitbtn}
                </Button>
              </div>
              <div className="clear"></div>
            </div>
         
        
		      </DialogContent>
          </Dialog>
		  
		  </div>
      </React.Fragment>
    );
}

}